var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    { attrs: { value: "" } },
    [
      _c(
        "w-card",
        { attrs: { "max-width": "900" } },
        [
          _c("w-card-title", [_vm._v("Snel kopie maken")]),
          _vm.step == 0
            ? _c("app-select-dossier", {
                attrs: {
                  "source-dossier": _vm.originalDossier,
                  "source-company": _vm.originalCompany,
                  "target-dossier": _vm.targetDossier,
                },
                on: {
                  dossier: function ($event) {
                    _vm.targetDossier = $event
                  },
                },
                model: {
                  value: _vm.targetDossier,
                  callback: function ($$v) {
                    _vm.targetDossier = $$v
                  },
                  expression: "targetDossier",
                },
              })
            : _vm.step == 1
            ? _c("app-set-move-user-datas", {
                attrs: {
                  "source-dossier": _vm.originalDossier,
                  "target-dossier": _vm.targetDossier,
                  "move-user-settings": _vm.moveUserDataSettings,
                },
                model: {
                  value: _vm.moveUserDataSettings,
                  callback: function ($$v) {
                    _vm.moveUserDataSettings = $$v
                  },
                  expression: "moveUserDataSettings",
                },
              })
            : _vm.step == 2
            ? _c("app-spinner")
            : _c("app-ready", {
                attrs: { "target-dossier": _vm.targetDossier },
              }),
          _vm.step != 2
            ? _c(
                "w-card-actions",
                [
                  _vm.step < 2
                    ? _c(
                        "w-button",
                        { staticClass: "cancel", on: { click: _vm.previous } },
                        [_vm._v(_vm._s(_vm.cancelText))]
                      )
                    : _vm._e(),
                  _c("w-spacer"),
                  _c(
                    "w-button",
                    {
                      attrs: { disabled: _vm.confirmDisabled },
                      on: { click: _vm.next },
                    },
                    [_vm._v(_vm._s(_vm.confirmText))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }